import React, { FunctionComponent } from 'react';
import { Typography } from '@mui/material';
import cx from 'classnames';
import { Switch } from '../../../../../components';
import styles from './InterventionHeader.styles';
import useStyles from './InterventionHeader.styles';

interface IProps {
  title: string;
  checked: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const InterventionHeader: FunctionComponent<IProps> = ({
  title,
  onChange,
  checked,
}) => {
  const classes = useStyles();
  return (
    <div>
      <div className={classes.titleWrapper}>
        <Typography
          variant="h2"
          className={cx({ [classes.titleUnchecked]: !checked })}
        >
          {title}
        </Typography>
        <Switch
          id="id"
          checked={checked}
          onChange={onChange}
          labelPlacement='start'
          customLabelClasses={classes.toggleLabel}
          label={!checked ? 'You can edit this intervention by turning toggle on' : ''}
        />
      </div>
    </div>
  );
};

export default InterventionHeader;
